import axios from 'axios'

interface Props {
  url: string,
  headerRow: number,
  startingDataRow: number,
  filterFunction: Function
}

export const fetchFromSheet = async (props : Props) => {
  try {
    const { data } = await axios({
      method: 'GET',
      url: props.url
    })

    const columnNames = (
      Object.values(
        Object.fromEntries(
          Object.entries(data[props.headerRow])
        )
      ) as any)

    const filteredData = props.filterFunction(
      data.slice(props.startingDataRow)
        .map(row => 
          Object.values(row).map((col, index) => (
            { 
              [columnNames[index]]: col 
            }
          ))
          .reduce((current, next) => (
            { 
              ...current, 
              ...next 
            }
          ), {})
        ))

    return filteredData

  }
  catch(e) {
    console.error(e)
    return null
  }
}

interface FetchFromSheet2DProps {
  url: string,
  key: string,
  filterFunction: Function
}

export const fetchFromSheet2D = async (props : FetchFromSheet2DProps) => {
  try {
    const { data } = await axios({
      method: 'GET',
      url: props.url
    })

    const filtered =  props.filterFunction(data)

    const object = filtered.reduce((obj, item) => Object.assign(obj, { [item[props.key]]: item }), {})

    return object

  }
  catch(e) {
    console.error(e)
    return null
  }
}
